export default "__VITE_ASSET__CELp2z4C__"